import SafeDrivingContentsLN from '@di-shared/features/safe-driving-LN/SafeDrivingContentsLN';
import SafeDrivingContentsVDSP from '@di-shared/features/safe-driving-vDSP/SafeDrivingContents';

export interface SafeDrivingPageProps {
  vin: string;
}

function SafeDrivingPage({vin}: SafeDrivingPageProps) {
  return (
    <>
      <SafeDrivingContentsVDSP vin={vin} />
      <SafeDrivingContentsLN vin={vin} />
    </>
  );
}

export default SafeDrivingPage;
